import React from 'react';
import { ChevronDown } from 'lucide-react';

const faqItems = [
  {
    question: 'Какой срок изготовления КТПН?',
    answer: 'От 50 до 75 рабочих дней, в зависимости от конфигурации и комплектации. Мы всегда стараемся оптимизировать сроки под ваш проект.'
  },
  {
    question: 'Можете ли вы адаптировать под нестандартные условия (вахта, вечная мерзлота)?',
    answer: 'Да, это наша специализация. Мы производим утеплённые КТПН в корпусе из сэндвич-панелей с надёжной системой защиты и подогрева для работы в экстремальных климатических условиях, включая Крайний Север.'
  },
  {
    question: 'Какие документы вы предоставляете?',
    answer: 'Мы предоставляем полный комплект документов: паспорт на изделие, сертификаты ТР ТС и ГОСТ, электрическую схему, инструкции по монтажу и эксплуатации.'
  },
  {
    question: 'Можно ли получить КП по ТЗ или файлу конкурента?',
    answer: 'Да, конечно. Просто приложите имеющиеся у вас файлы к заявке на сайте. Наши инженеры оперативно их изучат и предложат вам более выгодные условия.'
  }
];

const KtpnFaq: React.FC = () => {
  return (
    <section className="py-12 md:py-16 bg-gray-50">
      <div className="container-custom max-w-4xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-3xl md:text-4xl font-bold">
            Вопросы, которые нам чаще всего задают
          </h2>
        </div>
        <div className="space-y-4">
          {faqItems.map((item, index) => (
            <details key={index} className="group bg-white p-4 rounded-lg shadow-sm">
              <summary className="flex justify-between items-center font-semibold cursor-pointer list-none">
                <span>{item.question}</span>
                <ChevronDown className="w-5 h-5 transition-transform duration-300 group-open:rotate-180" />
              </summary>
              <div className="text-gray-600 mt-3 pt-3 border-t">
                {item.answer}
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
};

export default KtpnFaq; 